var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileNurse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.9994 0.285156C25.2777 0.285156 0.285156 25.2777 0.285156 55.9994C0.285156 86.7212 25.2777 111.714 55.9994 111.714C86.7212 111.714 111.714 86.7212 111.714 55.9994C111.714 25.2777 86.7212 0.285156 55.9994 0.285156ZM37.428 46.7137C37.428 36.4577 45.9894 28.1423 55.9994 28.1423C66.0094 28.1423 74.5709 36.4577 74.5709 46.7137V51.3566C74.5709 61.6127 66.0094 69.928 55.9994 69.928C45.9894 69.928 37.428 61.6127 37.428 51.3566V46.7137ZM55.9994 102.428C44.7034 102.428 34.3405 98.3609 26.2805 91.6287C30.1759 84.2791 37.8134 79.2137 46.7137 79.2137H65.2852C74.1855 79.2137 81.823 84.2791 85.7184 91.6287C77.6584 98.3609 67.2955 102.428 55.9994 102.428Z",
    fill: "#9095A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileNurse);
export default __webpack_public_path__ + "static/media/profileNurse.16463a5abc4fda8cfd9d72d2c7300b69.svg";
export { ForwardRef as ReactComponent };